import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import solidGauge from "highcharts/modules/solid-gauge.js";
import highchartsMore from "highcharts/highcharts-more";
import {
  colorMap,
  gaugeSelectStyles,
  getChartOptions,
} from "../../utils/utils";
import { tickRange } from "../../utils/helpers";
import Select from "../../../../components/common/Select/Select";
import ChartCard from "./ChartCard";

highchartsMore(Highcharts);
solidGauge(Highcharts);
const ManifoldAirPressureWidget = ({ height, width, airPressureData }) => {
  const [data, setData] = useState(null);
  const chartType = ["Dial Gauge", "Digital"];
  const [defaultType, setDefaultType] = useState(chartType[0]);

  const handleTypeChange = (val) => {
    setDefaultType(val);
  };
  let tickRangeArray;
  let plotBandsArray;

  useEffect(() => {
    setData(airPressureData);
  }, [airPressureData]);

  if (data) {
    tickRangeArray = tickRange(
      data?.manifoldAirPressureDto[0]?.minValue,
      data?.manifoldAirPressureDto[0]?.maxValue,
      5
    );
    plotBandsArray = data?.colorRanges
      ?.sort((a, b) => (a.start > b.start ? 0 : -1))
      .map((range) => ({
        from: range.start,
        to: range.end,
        color: colorMap[range.color],
        innerRadius: "75%",
        outerRadius: "100%",
      }));
  }

  const options = getChartOptions({
    height: height,
    width: width,
    minValue: data?.manifoldAirPressureDto[0]?.minValue,
    maxValue: data?.manifoldAirPressureDto[0]?.maxValue,
    currentValue: data?.manifoldAirPressureDto[0]?.currentValue,
    unit: data?.manifoldAirPressureDto[0]?.unit,
    plotBandsArray: plotBandsArray,
    tickRangeArray: tickRangeArray,
    chartText: "Manifold Air Pressure ",
  });

  return (
    <div
      style={{
        background: "#F2F7FD",
        borderRadius: "10px",
        position: "relative",
        height: "100%",
      }}
    >
      <div style={{ position: "absolute", zIndex: "1", right: "-10px" }}>
        <Select
          options={chartType}
          defaultSelected={defaultType}
          handleOptionClick={handleTypeChange}
          containerClass="realtime-gauge-select"
          styles={gaugeSelectStyles}
        />
      </div>
      {defaultType === chartType[0] ? (
        <HighchartsReact highcharts={Highcharts} options={options} />
      ) : (
        <>
          <ChartCard
            currentValue={data?.manifoldAirPressureDto[0]?.currentValue}
            unit={data?.manifoldAirPressureDto[0]?.unit}
            chartText="Manifold Air Pressure"
          />
        </>
      )}
    </div>
  );
};

export default ManifoldAirPressureWidget;
